import { client } from '../utils/http';
import { Challenge, ChallengeId, RestrictedChallenge } from '../types/challenge';
import { Participant, ParticipantChallengeData, ParticipantId } from '../types/participant';

export async function getChallengeById(challengeId?: ChallengeId): Promise<Challenge> {
  const response = await client.get(`/api/partial-auth/challenges/${challengeId}`);
  return Challenge.parse(response.data);
}

export async function getRestrictedChallengeById(challengeId?: ChallengeId): Promise<RestrictedChallenge> {
  const response = await client.get(`/api/no-auth/challenges/restricted/${challengeId}`);
  return RestrictedChallenge.parse(response.data);
}
export async function getParticipantForChallenge(challengeId?: ChallengeId): Promise<Participant | null> {
  const response = await client.get(`/api/partial-auth/participants/challenges/${challengeId}`);
  return response.data ? Participant.parse(response.data) : null;
}
export async function removeParticipantFromChallenge(challengeId?: ChallengeId, participantId?: ParticipantId): Promise<void> {
  await client.delete(`/api/partial-auth/participants/${participantId}`);
}
export async function addParticipantToChallenge(
  challengeId?: ChallengeId,
  challengeData?: ParticipantChallengeData,
  utmParams?: Record<string, string>,
): Promise<ParticipantId> {
  const response = await client.post('/api/partial-auth/participants', { challengeData, challengeId, utmParams });
  return response.data;
}

export async function updateParticipantChallengeGoal(participantId: ParticipantId, challengeGoal: number): Promise<Participant> {
  const response = await client.put(`/api/partial-auth/participants/${participantId}`, { challengeGoal });
  return response.data;
}
export async function getNonParticipantChallengeData(challengeId?: ChallengeId): Promise<ParticipantChallengeData> {
  const response = await client.get(`/api/partial-auth/participants/${challengeId}/non-participant-challenge-data`);
  return ParticipantChallengeData.parse(response.data);
}
